<template>
  <div class="ts-border ts-border-gray-300 ts-rounded-md ts-p-4 ts-space-y-2">
    <div class="row">
      <label class="col-md-3 col-form-label ts-text-xs required ts-font-light">
        {{ $t('productPriceSchema.tableType') }}
      </label>
      <div class="col-md-4">
        <a-select v-model="model.guest_level_id" :options="guestLevels" show-search option-filter-prop="children"
          class="ts-w-full" :class="{ 'is-invalid': errors.has('guest_level_id') }" placeholder="Select"
          @change="onChangeMain"></a-select>
        <div class="validate ts-text-xs" v-if="errors.has('guest_level_id')">
          {{ errors.first('guest_level_id') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-md-3 col-form-label ts-text-xs required ts-font-light">
        {{ $t('productPriceSchema.incrementType') }}
      </label>
      <div class="col-md-4">
        <a-select v-model="model.increment_type" :options="incrementTypes" class="ts-w-full"
          :class="{ 'is-invalid': errors.has('increment_type') }" placeholder="Select"
          @change="onChangeMain"></a-select>
        <div class="validate ts-text-xs" v-if="errors.has('increment_type')">
          {{ errors.first('increment_type') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-md-3 col-form-label ts-text-xs required ts-font-light">
        {{ $t('productPriceSchema.incrementAmount') }}
      </label>
      <div class="col-md-4">
        <input v-model="model.increment_amount" type="number" class="form-control"
          :class="{ 'is-invalid': errors.has('increment_amount') }" @change="onChangeMain" />
        <div class="validate ts-text-xs" v-if="errors.has('increment_amount')">
          {{ errors.first('increment_amount') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('restaurantSale/productPriceSchema', ['formViewDatas']),
    guestLevels() {
      if (this.formViewDatas['guestLevels']) {
        return this.formViewDatas['guestLevels'].map(el => ({
          value: el.id,
          label: el.guest_level_name_en
        }))
      }
      return []
    },
    incrementTypes() {
      return [
        {
          value: '%',
          label: '%'
        },
        {
          value: this.$store.state.authUser.sys_setting.default_currency_sign,
          label: this.$store.state.authUser.sys_setting.default_currency_sign
        },
      ]
    },
  },
  methods: {
    onChangeMain() {
      this.model.product_list.forEach(el => {
        el.guest_level_id = this.model.guest_level_id;
        el.increment_amount = this.model.increment_amount;
        el.increment_type = this.model.increment_type;
      });
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>